import { getMyOrganization, Organization } from "@src/redux/index";
import { Col, Form, FormInstance, Input, Row, Select } from "antd";
import { startCase } from "lodash";
import React from "react";
import { useSelector } from "react-redux";

interface Props {
  form: FormInstance;
  options: any;
  handleChange: any;
  index: any;
  label?: string;
  isRequired: boolean;
  allowClear: boolean;
  className?: string;
  levelAttributes?: any;
  showLevelAttribute?: boolean;
  handleChangeLevelAttributes: any;
  myOrganizationResult?: Organization | null;
  showAllLabel?: boolean;
  setLastOrgId?: (id: string) => void;
}
const DynamicOrgSelect: React.FC<Props> = (props) => {
  const {
    options,
    handleChange,
    index,
    label,
    isRequired,
    allowClear,
    className,
    levelAttributes,
    showLevelAttribute = false,
    handleChangeLevelAttributes,
    showAllLabel = true,
    setLastOrgId
  } = props;

  return (
    <div key={index}>
      {showLevelAttribute &&
      <Row gutter={10} className="level-attribute-list-container">
          {levelAttributes?.[label || ""] &&
        levelAttributes?.[label || ""]?.length > 0 ?
        (levelAttributes?.[label || ""]).map(
          (list, levelAttributeIndex) => {
            let options =
            list?.optionList && list?.optionList?.length > 0 ?
            list?.optionList?.map((option) => {
              return {
                label: startCase(option),
                value: option
              };
            }) :
            [];
            return (
              <Col
                span={
                levelAttributes?.[label || ""]?.length > 1 ? 12 : 24}>

                
                      <Form.Item
                  name={[
                  "levelAttributeId",
                  levelAttributeIndex,
                  "id"]}

                  label={list?.name}
                  className={className}
                  hidden
                  initialValue={list?.id}>
                </Form.Item>
                      <Form.Item
                  name={[
                  "levelAttributeId",
                  levelAttributeIndex,
                  "value"]}

                  label={list?.name}
                  className={className}>
                  
                        <Select
                    options={options}
                    onChange={(value: string) =>
                    handleChangeLevelAttributes(
                      value,
                      label,
                      options?.[0],
                      index
                    )} />

                  
                      </Form.Item>
                    </Col>);

          }
        ) :
        ""}
        </Row>}
      
      <Form.Item
        name={["organizationId", index]}
        label={label}
        rules={[{ required: isRequired, message: `${label} is required` }]}
        className={className}>
        
        <Select
          options={options}
          onChange={(value: string, option: any) =>
          handleChange(value, label, option, index)}

          fieldNames={{ label: "name", value: "id" }}
          allowClear={allowClear} />
        
      </Form.Item>
    </div>);

};

export default DynamicOrgSelect;